/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { signInWithProvider } from '../../application/sso';
import { authFormUi } from './authFormUi';

type Props = {
  disabled?: boolean;
};

/**
 * SSO en login y signup. Solo Google: Apple no está habilitado en Supabase Auth.
 * Mismo `signInWithOAuth`: si la cuenta no existe, Supabase la crea.
 */
export function AuthSsoSection({ disabled = false }: Props) {
  return (
    <View accessibilityLabel="Continuar con Google">
      <View style={authFormUi.ssoRow}>
        <TouchableOpacity
          style={authFormUi.ssoButton}
          onPress={() => void signInWithProvider('google')}
          disabled={disabled}
          accessibilityLabel="Continuar con Google"
          accessibilityRole="button"
          accessibilityState={{ disabled }}
          testID="auth.sso.google"
        >
          <Ionicons name="logo-google" size={18} color={ticketColors.ink} />
          <Text style={authFormUi.ssoLabelText}>Continuar con Google</Text>
        </TouchableOpacity>
      </View>
      <View style={[authFormUi.separator, { marginTop: 16 }]} accessibilityRole="text">
        <View style={authFormUi.separatorLine} />
        <Text style={authFormUi.separatorText}>o con correo</Text>
        <View style={authFormUi.separatorLine} />
      </View>
    </View>
  );
}
